import * as React from "react";
import defaultImage from "src/assets/images/default-topic.png";
import { useAppContext } from "src/context/AppContext";
import { Card, Props, Title } from "./styled";

const TopicCard: React.FC<Props> = (props) => {
  const { title, exhibitid } = props;
  const appContext = useAppContext();
  const [image, setImage] = React.useState<string>(defaultImage);

  //useEffect to set image based on exhibitId
  React.useEffect(() => {
    const exhibit = appContext.getExhibit(exhibitid);
    if (exhibit) {
      setImage(
        exhibit.exhibitImage || exhibit.exhibitImageThumb || defaultImage
      );
    }
  }, [exhibitid, appContext]);

  return (
    <Card
      image={image}
      onClick={() => appContext.setSelectedExhibitId(exhibitid)}
      className={props.className} // Forward className to Card
    >
      {/* <img src={image} alt={title} style={{ width: "100%", height: "auto", display: "block" }} /> */}
      <Title>{title}</Title>
    </Card>
  );
};

export default TopicCard;
